const SERIES_COLORS = [
    '#427CAC',
    '#00bfa9',
    '#ff7300',
    '#8884d8',
    '#d6b302',
    '#e91e63',
    '#3BAE3B',
    '#6096C3',
    '#9c27b0',
    '#795548'
]

export const getSeriesColor = (index) => SERIES_COLORS[index % SERIES_COLORS.length]

export const formatNumber = (value) => {
    if (value === undefined || value === null || Number.isNaN(value)) return '—'
    return Number(value).toLocaleString('pt-BR')
}

export const formatPercent = (value) => {
    if (value === undefined || value === null || Number.isNaN(value)) return '—'
    const sign = value > 0 ? '+' : ''
    return `${sign}${Number(value).toFixed(1)}%`
}

export const mergeSeriesToChartData = (series = {}) => {
    const labels = new Set()
    Object.values(series).forEach((points) => {
        ;(points || []).forEach((point) => labels.add(point.label))
    })

    return [...labels].sort().map((label) => {
        const row = { label }
        Object.entries(series).forEach(([key, points]) => {
            const found = (points || []).find((point) => point.label === label)
            row[key] = found ? found.value : 0
        })
        return row
    })
}

export const chartPointsToData = (points = []) =>
    (points || []).map((point) => ({
        label: point.label,
        value: point.value
    }))

export const formatGranularity = (granularity) => {
    const labels = {
        day: 'dia',
        week: 'semana',
        month: 'mês'
    }
    return labels[granularity] || granularity
}

export const getAnalyticsErrorMessage = (error) => {
    const status = error?.response?.status
    if (status === 401) {
        return 'Sessão expirada ou token inválido. Faça login novamente.'
    }
    if (status === 403) {
        return 'Acesso negado. É necessário perfil SUPER_ADMIN para visualizar as análises.'
    }
    if (status === 404) {
        return 'Endpoint de análises não encontrado. Verifique se a API está atualizada.'
    }
    if (!error?.response) {
        return 'Não foi possível conectar à API de análises. Verifique se o backend está rodando.'
    }
    return error?.response?.data?.message || 'Erro ao carregar dados de análises.'
}
